import { AnchorPointAssignmentBodySchema, AnchorPointResponseSchema, FloorPlanAnchorPointParamsSchema, FloorPlanDeleteResponseSchema, FloorPlanFloorParamsSchema, FloorPlanImageUrlResponseSchema, FloorPlanListResponseSchema, FloorPlanResponseSchema, FloorPlanSiteParamsSchema, FloorPlanUpdateBodySchema, FloorPlanUploadFormSchema, } from '../../schemas.js';
const locationBase = { base: 'location' };
/** REST contract for tenant floor plan routes. */
export const locationFloorPlansContract = {
    listFloorPlans: {
        method: 'GET',
        path: '/location/sites/:siteId/floor-plans',
        pathParams: FloorPlanSiteParamsSchema,
        response: FloorPlanListResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to list floor plans',
        ...locationBase,
    },
    getFloorPlanImageUrl: {
        method: 'GET',
        path: '/location/sites/:siteId/floor-plans/:floorId/image',
        pathParams: FloorPlanFloorParamsSchema,
        response: FloorPlanImageUrlResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get floor plan image URL',
        ...locationBase,
    },
    uploadFloorPlan: {
        method: 'POST',
        path: '/location/sites/:siteId/floor-plans',
        pathParams: FloorPlanSiteParamsSchema,
        body: FloorPlanUploadFormSchema,
        bodyStyle: 'form-data',
        response: FloorPlanResponseSchema,
        responseStyle: 'parse-response',
        timeoutMs: 120000,
        errorMessage: 'Failed to upload floor plan',
        ...locationBase,
    },
    updateFloorPlan: {
        method: 'PUT',
        path: '/location/sites/:siteId/floor-plans/:floorId',
        pathParams: FloorPlanFloorParamsSchema,
        body: FloorPlanUpdateBodySchema,
        response: FloorPlanResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to update floor plan',
        ...locationBase,
    },
    deleteFloorPlan: {
        method: 'DELETE',
        path: '/location/sites/:siteId/floor-plans/:floorId',
        pathParams: FloorPlanFloorParamsSchema,
        response: FloorPlanDeleteResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to delete floor plan',
        ...locationBase,
    },
    updateAnchorPointAssignment: {
        method: 'PATCH',
        path: '/location/sites/:siteId/floor-plans/:floorId/anchor-points/:anchorPointId/assignment',
        pathParams: FloorPlanAnchorPointParamsSchema,
        body: AnchorPointAssignmentBodySchema,
        response: AnchorPointResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to update anchor point assignment',
        ...locationBase,
    },
};
//# sourceMappingURL=location-floor-plans.contract.js.map